import type { Store } from "vuex";
import api from "@/api";
import { useDisplayStore } from "@/stores/display";
import { useFeaturesStore } from "@/stores/features";
import { useSessionStore } from "@/stores/session";
import type { BootResult } from "@/router/guards";

export const boot = async (store: Store<any>): Promise<BootResult> => {
    let user;

    try {
        user = await api.users.get();
    } catch (e) {
        // No account to administer.
        return { status: "denied" };
    }

    try {
        const displayData = await api.strings.displayData();

        useDisplayStore().update(displayData);
        useFeaturesStore().update(user.admin_access);
        useSessionStore().init(user);

        store.commit("setLoginUser", user);
        store.dispatch("applyUser", user);
        store.dispatch("updateTree");
    } catch (e) {
        // They have an account, so "try again" is better advice than "log in
        // as someone else".
        return { status: "error" };
    }

    return { status: "ok", user };
};
